module.exports = __webpack_public_path__ + "img/sqxgj.261da23.png";